export const ROLES = {
    ADMIN: 'admin',
    REVIEWER: 'reviewer',
    VIEWER: 'viewer',
};

/**
 * Checks if a user has a specific role.
 * @param {Object} user - The user object from Redux state (auth.user).
 * @param {string} role - The role to check against.
 * @returns {boolean}
 */
export const hasRole = (user, role) => {
    if (!user || !user.user) return false;
    // Layering on top of existing checks: if explicitly asking for admin, check legacy is_admin too for safety? 
    // User requested layering GB roles on top.
    // 'admin' role usually implies is_admin=true, but we'll check the string.

    // Case insensitive check just in case
    return user.user.user_role?.toLowerCase() === role.toLowerCase();
};

/**
 * Checks if a user has any of the allowed roles.
 * @param {Object} user - The user object.
 * @param {Array<string>} allowedRoles - Array of allowed role strings.
 * @returns {boolean}
 */
export const hasAnyRole = (user, allowedRoles) => {
    if (!user || !user.user) return false;
    if (!allowedRoles || allowedRoles.length === 0) return false;

    const userRole = user.user.user_role?.toLowerCase();
    return allowedRoles.some(role => role.toLowerCase() === userRole);
};

export const canViewDashboard = (user) => hasRole(user, ROLES.ADMIN);
export const canCreateForms = (user) => hasRole(user, ROLES.ADMIN);
export const canViewEmployees = (user) => hasRole(user, ROLES.ADMIN);
export const canViewUsers = (user) => hasRole(user, ROLES.ADMIN);

export const canViewDiscrepancies = (user) => hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]);
export const canViewFeedback = (user) => hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]);

export const canEditApplications = (user) => hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]);
export const canProcessApplications = (user) => hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]);
export const canAssignApplications = (user) => hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]);
export const canViewCompanies = (user) => hasRole(user, ROLES.ADMIN);
